import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { UpdateDocumentArchivesPayload, UpdateDocumentArchivesInput } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
const MUTATION_ACKNOWLEDGE_DOCUMENT_ARCHIVE = gql`
    mutation updateDocumentArchiveAcknowledgementStatus($input: UpdateDocumentArchivesInput!){
        updateDocumentArchiveAcknowledgementStatus(input: $input){
            message
            errors {
                code
                message
            }
            result
        }
    }
`;

export const mutationAcknowledgeDocumentArchives = async (
    client: ApolloClient<NormalizedCacheObject>,
    args: {
        inputData: UpdateDocumentArchivesInput
    }
): Promise<UpdateDocumentArchivesPayload | undefined> => {
    const { documentArchiveIds, noteHeader, note } = args.inputData;
    const { data, errors } = await client.mutate<{ updateDocumentArchiveAcknowledgementStatus: UpdateDocumentArchivesPayload }>({
        variables: {
            input: {
                documentArchiveIds,
                noteHeader,
                note
            }
        },
        mutation: MUTATION_ACKNOWLEDGE_DOCUMENT_ARCHIVE
    });
    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console
            console.error(error);
        });
        // Friendly error to active user
        throw new Error('An error has occurred during the document archive(s) acknowledgement and note save.');
    }
    if (data && data.updateDocumentArchiveAcknowledgementStatus) {
        return data.updateDocumentArchiveAcknowledgementStatus;
    }
    return undefined;
};